/* Requiere de genesys.js */

var vinvuloArt = {
	data () {
		return {
            vinculoArt: []
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getVinvuloArt(codartsA) {
			let codarts = codartsA.reduce(function(a, b) { let c = (a != '') ? ', ' + b : b; return a + c}, '');
			let url = this.urlAPIVinculoArt + '/getArtVinculado?codigo=' + codarts
			//this.$emit('showLockScreen', 'Buscando articulos vinculados a ' + codarts)
			//console.log('Buscando articulos vinculados a ' + codarts)
			this.searching = true
            this.axios.get(url)
                .then(response => { this.resultGetVinvuloArt(response); /*this.$emit('hideLockScreen');*/ this.searching = false })
                .catch(error  => { console.log(error); /*this.$emit('hideLockScreen');*/ this.searching = false })
        },
        resultGetVinvuloArt(response) {
			this.vinculoArt = response.data.data
        }
	},
};

export default vinvuloArt;